/**
 * Centralised SEO config for Ashlan Clinic.
 * Owns the public/production canonical URL, default OG image, and shared
 * organisation schema fragments. Edit here when business details change.
 */

// Production canonical host. Preview deploys still set proper meta but link
// canonicals back to production so duplicate-content penalties don't apply.
export const SITE_URL = "https://beta.ashlanclinic.com";

export const SITE_NAME = "Ashlan Clinic";

export const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_clinical-massage-bda/artifacts/hyr0rc80_HERO%20IMAGE%20-%20MASSAGE%203.png";

export const DEFAULT_DESCRIPTION =
  "Long established as one of Bermuda's most trusted practices for clinical massage therapy, Ashlan Clinic is distinguished by the experience of its Therapists.";

export const BUSINESS = {
  name: SITE_NAME,
  legalName: "Ashlan Clinic",
  url: SITE_URL,
  phone: "+1-441-292-6830",
  email: "info@ashlanclinic.com",
  streetAddress: "48 Cedar Avenue",
  addressLocality: "Hamilton",
  postalCode: "HM 11",
  addressCountry: "BM",
  // Approximate central Hamilton coords — refine if you have exact lat/lng.
  latitude: 32.2949,
  longitude: -64.7821,
  // Hours: closed Sunday, otherwise Mon–Sat. Adjust as needed.
  hours: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "18:00" },
    { days: ["Saturday"], opens: "09:00", closes: "14:00" },
  ],
  sameAs: [
    // Add your real social profiles here when ready.
    // "https://www.facebook.com/ashlanclinic",
    // "https://www.instagram.com/ashlanclinic",
  ],
};

/** Base LocalBusiness + MedicalBusiness schema used on every page. */
export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "MedicalBusiness"],
    "@id": `${SITE_URL}/#organization`,
    name: BUSINESS.name,
    url: BUSINESS.url,
    telephone: BUSINESS.phone,
    email: BUSINESS.email,
    image: DEFAULT_OG_IMAGE,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: BUSINESS.streetAddress,
      addressLocality: BUSINESS.addressLocality,
      postalCode: BUSINESS.postalCode,
      addressCountry: BUSINESS.addressCountry,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: BUSINESS.latitude,
      longitude: BUSINESS.longitude,
    },
    openingHoursSpecification: BUSINESS.hours.map((h) => ({
      "@type": "OpeningHoursSpecification",
      dayOfWeek: h.days,
      opens: h.opens,
      closes: h.closes,
    })),
    sameAs: BUSINESS.sameAs,
  };
}

/** Build a fully-qualified canonical URL for a given path. */
export function absoluteUrl(path = "/") {
  if (!path.startsWith("/")) path = `/${path}`;
  return `${SITE_URL}${path}`;
}
